export default [
  {
    path: '/satis-urun',
    name: 'satis-urun-list',
    component: () => import('./index.vue'),
    meta: {
      public: false,
      title: 'satis_urun.Baslik',
      yetki: { k: ['2002102'] },
    },
  },
  {
    path: '/satis-urun/komisyon/:uuid',
    name: 'satis-urun-komisyon',
    component: () => import('./komisyon/index.vue'),
    meta: {
      public: false,
      title: 'satis_urun.Baslik Komisyon',
      yetki: { k: ['2002102'] },
    },
  },
]
